import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import SnackBarComponent from '../../../../components/formlib/SnackBarComponent';
import { AlertColor, Grid } from '@mui/material';
import { IfspConsentSignatureType } from '../../../../redux/features/ifsp/ifspSDPAndConsentSlice';
import ButtonComponent from '../../../../components/formlib/ButtonComponent';
import CheckBoxComponent from '../../../../components/formlib/CheckBoxComponent';
import DatePickerComponent from '../../../../components/formlib/DatePickerComponent';
import dayjs, { Dayjs } from 'dayjs';
import MediumTypography from '../../../../components/formlib/MediumTypography';
import SignatureComponent from '../../../../components/formlib/modal/SignatureComponent';
import { ReactComponent as Editsignature } from '../../../../assets/images/editsignature.svg';
import { SignatureStateType } from '../../../../utils/type';
import { datePickerMinDateMaxDateValidate } from '../../../../utils/dateUtil';
import { useAppSelector } from '../../../../redux/hooks';

type IfspConsentSigntureProps = {
  signatures: IfspConsentSignatureType;
  onUpdateSignature: (updatedSignature: IfspConsentSignatureType) => void;
  index: number;
  isVerbalConsentRequired?: boolean;
  isPaperConsentRequired?: boolean;
  disabled: boolean;
};

const IfspConsentSignture = ({
  signatures,
  onUpdateSignature,
  index,
  isVerbalConsentRequired,
  isPaperConsentRequired,
  disabled,
}: IfspConsentSigntureProps) => {
  const ifspPermissiom = useAppSelector((state) => state.ifspPermissionDetails);
  const [signature, setSignature] =
    useState<IfspConsentSignatureType>(signatures);
  const [signClicked, setSignClicked] = useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [toastrVariable, setToastrVariable] = useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = useState('');
  const [toastrId, setToastrId] = useState('');

  useEffect(() => {
    onUpdateSignature(signature);
  }, [signature]);

  const handleCloseSnakBar = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };

  const signatureCallBack = (response: SignatureStateType[]) => {
    setSignature({
      ...signature,
      signature: response[0].signaturedata,
      verbalConsent: response[0].verbalConsent,
      paperConsent: response[0].paperConsent,
    });
  };

  const signatureSaveOrUPdate = (signed: string) => {
    setSignature({
      ...signature,
      signature: signed,
    });
    setSignClicked(!signClicked);
  };

  const onCancelClick = () => {
    setSignClicked(false);
  };

  const handleSuccess = (successError: AlertColor, id: string, mes: string) => {
    setOpenSnackBar(true);
    setToastrVariable(successError);
    setToastrId(id);
    setToastrDefaultMessage(mes);
  };

  return (
    <Box component="main">
      <SnackBarComponent
        open={openSnackBar}
        handleClose={handleCloseSnakBar}
        successOrError={toastrVariable}
        labelId={toastrId}
        defaultMessageId={toastrDefaultMessage}
      />
      <Box component="section" className="pt-lg">
        {!signature.signature && !signature.rowKey && (
          <>
            <Box component="div" className="flex__ align__items__center">
              <ButtonComponent
                className="btn-primary btn-cancel signature_add_Box"
                labelId="Insurance.Addsignature"
                defaultLabelId="Add Signature"
                variantType="outlined"
                onClick={() => {
                  setSignClicked(!signClicked);
                }}
                disabled={
                  disabled || signature.verbalConsent || signature.paperConsent
                }
              />
              <Grid container flexDirection={'column'}>
                <Grid item className="pl-lg flex__ align__items__center">
                  <CheckBoxComponent
                    ischecked={
                      isVerbalConsentRequired
                        ? signature.verbalConsent
                        : signature.paperConsent
                    }
                    CheckHandleChange={(val) => {
                      setSignature({
                        ...signature,
                        verbalConsent: isVerbalConsentRequired
                          ? val.target.checked
                          : signature.verbalConsent,
                        paperConsent: isPaperConsentRequired
                          ? val.target.checked
                          : signature.paperConsent,
                      });
                    }}
                    disabled={Boolean(
                      disabled || signature.signature || signature.rowKey,
                    )}
                    defaultlabelid={
                      isPaperConsentRequired
                        ? 'Paper Consent'
                        : 'Paper Consent/Verbal Consent'
                    }
                    labelid={
                      isPaperConsentRequired
                        ? 'IFSP.PaperConsent'
                        : 'IFSP.VerbalConsent'
                    }
                  />
                </Grid>
                <Grid item className="pl-lg" sx={{ marginLeft: '8px' }} xs={3}>
                  <DatePickerComponent
                    key={signature.date}
                    className="bg__white"
                    labelid={'Date'}
                    defaultlabelid={'Date'}
                    value={dayjs(signature.date)}
                    handlechange={(dateValue: Dayjs | null) => {
                      if (dateValue) {
                        const formattedDate =
                          dayjs(dateValue).format('MM/DD/YYYY');
                        setSignature({
                          ...signature,
                          date: formattedDate,
                        });
                      } else {
                        setSignature({
                          ...signature,
                          date: '',
                        });
                      }
                    }}
                    disabledDate={
                      (disabled &&
                        !ifspPermissiom.hasIfspEditPermissionAfterLock) ||
                      (((isVerbalConsentRequired && !signature.verbalConsent) ||
                        (isPaperConsentRequired && !signature.paperConsent)) &&
                        !signature.signature &&
                        !signature.rowKey)
                    }
                  />
                </Grid>
                {(signature.verbalConsent ||
                  signature.signature ||
                  signature.paperConsent) &&
                !signature.date ? (
                  <Grid
                    item
                    className="pl-lg"
                    sx={{ marginLeft: '8px' }}
                    xs={3}
                  >
                    <MediumTypography
                      labelid="IFSP.DateRed"
                      defaultlabel="Date is required"
                      textColor="red"
                    />
                  </Grid>
                ) : null}
                {(signature.verbalConsent ||
                  signature.signature ||
                  signature.paperConsent) &&
                signature.date &&
                datePickerMinDateMaxDateValidate(signature.date) ? (
                  <Grid
                    item
                    className="pl-lg"
                    sx={{ marginLeft: '8px' }}
                    xs={3}
                  >
                    <MediumTypography
                      labelid="datePickerMinDateMaxDateValidate"
                      defaultlabel="Date is invalid"
                      textColor="red"
                    />
                  </Grid>
                ) : null}
              </Grid>
            </Box>
            {index === 1 ? (
              <MediumTypography
                labelid="IFSP.Optional"
                defaultlabel="(Optional)"
                className="pt-md"
                textColor="#97a6a5"
              />
            ) : null}
          </>
        )}
        {(signature.signature || signature.rowKey) && (
          <Box component="div" className="flex__ align__items__center">
            <ButtonComponent
              className="btn-primary btn-cancel signature_view_Box"
              labelId="Insurance.Viewsignature"
              defaultLabelId="View/update signature"
              variantType="outlined"
              LeftIcon={<Editsignature />}
              onClick={() => {
                setSignClicked(!signClicked);
              }}
            />
            <Grid container flexDirection={'column'}>
              <Grid item className="pl-lg flex__ align__items__center">
                <CheckBoxComponent
                  ischecked={
                    isVerbalConsentRequired
                      ? signature.verbalConsent
                      : signature.paperConsent
                  }
                  CheckHandleChange={(val) => {
                    const updatedSignatures = signature;
                    updatedSignatures.verbalConsent = isVerbalConsentRequired
                      ? val.target.checked
                      : signature.verbalConsent;
                    updatedSignatures.paperConsent = isPaperConsentRequired
                      ? val.target.checked
                      : signature.paperConsent;
                    setSignature(updatedSignatures);
                  }}
                  disabled={Boolean(
                    disabled || signature?.signature || signature?.rowKey,
                  )}
                  defaultlabelid={
                    isPaperConsentRequired
                      ? 'Paper Consent'
                      : 'Paper Consent/Verbal Consent'
                  }
                  labelid={
                    isPaperConsentRequired
                      ? 'IFSP.PaperConsent'
                      : 'IFSP.VerbalConsent'
                  }
                />
              </Grid>
              <Grid item className="pl-lg" sx={{ marginLeft: '8px' }} xs={3}>
                <DatePickerComponent
                  key={signature.date}
                  className="bg__white"
                  labelid={'Date'}
                  defaultlabelid={'Date'}
                  value={dayjs(signature.date)}
                  handlechange={(dateValue: Dayjs | null) => {
                    if (dateValue) {
                      const formattedDate =
                        dayjs(dateValue).format('MM/DD/YYYY');
                      setSignature({
                        ...signature,
                        date: formattedDate,
                      });
                    } else {
                      setSignature({
                        ...signature,
                        date: '',
                      });
                    }
                  }}
                  disabledDate={
                    (disabled &&
                      !ifspPermissiom.hasIfspEditPermissionAfterLock) ||
                    (!signature.verbalConsent &&
                      !signature.signature &&
                      !signature.rowKey)
                  }
                />
              </Grid>
              {(signature.verbalConsent ||
                signature.paperConsent ||
                signature.signature) &&
              !signature.date ? (
                <Grid item className="pl-lg" sx={{ marginLeft: '8px' }} xs={3}>
                  <MediumTypography
                    labelid="IFSP.DateRed"
                    defaultlabel="Date is required"
                    textColor="red"
                  />
                </Grid>
              ) : null}
              {(signature.verbalConsent ||
                signature.paperConsent ||
                signature.signature) &&
              signature.date &&
              datePickerMinDateMaxDateValidate(signature.date) ? (
                <Grid item className="pl-lg" sx={{ marginLeft: '8px' }} xs={3}>
                  <MediumTypography
                    labelid="datePickerMinDateMaxDateValidate"
                    defaultlabel="Date is invalid"
                    textColor="red"
                  />
                </Grid>
              ) : null}
            </Grid>
          </Box>
        )}
      </Box>
      {/* Signature pad */}

      {signClicked && (
        <Box component="div">
          <SignatureComponent
            hideResetButton={
              disabled || signature.verbalConsent || signature.paperConsent
            }
            signClicked={signClicked}
            signature={signature.signature || ''}
            labelId="parentSignatureId"
            defaultLabelId="Parent Signature"
            onCancelClick={onCancelClick}
            signaturePartitionKey={signature.partitionKey || ''}
            signatureRowKey={signature.rowKey || ''}
            signatureCallBack={signatureCallBack}
            signatureSaveOrUPdate={signatureSaveOrUPdate}
            handleSuccess={handleSuccess}
            type="Others"
          />
        </Box>
      )}
    </Box>
  );
};

export default IfspConsentSignture;
